import { FETCH_TYPE_SYNCH, FETCH_TYPE_ASYNCH } from '../../common/lib/utils/constants.js';
import formRedirect, { transformAndPost } from '../components/form-redirect.js';
import { fetchfingerPrintData as getFingerPrintData } from '../components/get-finger-print-data.js';
import { externalIframeRequest } from '~/components/brand/ducks/index.js';

function actualSendHandlerEffect({
	result,
	setUrlParams,
	isDesktop,
	isIntegrationTesting,
	dispatch,
	location,
	setPromptNativeAppInfo,
	doneCallback,
	prevProps,
	formRedirectOnHiddenIframe,
	bindThreeDSListenerEvent,
	setTwoFact,
	transformPathAndPush,
	qdDepositFlow = false
}) {
	const {
		accHistRef,
		actualSendHandler,
		externalMethod,
		externalParameters,
		externalUrl,
		paymentFetchResultFlow,
		form
	} = result;

	const openPanel = isDesktop || qdDepositFlow;

	/* for types 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL' and 'RESULT_AFTER_SINGLE_CALL' the
			 result-page is opened directly with 'openDeposit'
			 The types 'EXTERNAL_PANEL' and 'EXTERNAL_WINDOW' creates a redirection.
			*/

	switch (actualSendHandler) {
		case 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL':
		case 'RESULT_AFTER_SINGLE_CALL':
			// TODO: the result-page may be opened in other way, but the
			// current scope of refactoring ends here. Probably better to
			// add the result-component as the next step in the wizard for example,
			// and exit this component from 'onSuccess'.
			setUrlParams(accHistRef, {
				fetch_type:
					actualSendHandler === 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL'
						? FETCH_TYPE_ASYNCH
						: FETCH_TYPE_SYNCH,
				accHistRef,
				paymentFetchResultFlow
			});
			break;
		case 'EXTERNAL_PANEL':
		case 'EXTERNAL_WINDOW':
			if (actualSendHandler === 'EXTERNAL_PANEL' && openPanel && !isIntegrationTesting) {
				dispatch(
					externalIframeRequest({
						iframeExternalRequestUrl: externalUrl,
						iframeExternalParams: externalParameters,
						sendExternalParams: true
					})
				);

				if (location?.state?.current !== 'external-request' && !qdDepositFlow) {
					// TODO (navigation) - use search params or redux for state
					transformPathAndPush('/external-request', {
						current: 'external-request'
					});
				}
			} else {
				formRedirect(externalUrl, externalParameters, externalMethod);
			}
			break;
		case 'TEXT_HTML':
			transformAndPost(form);
			break;
		case 'NATIVE_APP':
			setPromptNativeAppInfo(true);

			break;
		case 'INTERNAL_HIDDEN_IFRAME':
		case 'INTERNAL_HIDDEN_IFRAME_POST_MESSAGE':
			if (!prevProps?.result || prevProps?.result?.accHistRef !== accHistRef) {
				formRedirectOnHiddenIframe(accHistRef, externalUrl, externalParameters);
				if (actualSendHandler === 'INTERNAL_HIDDEN_IFRAME_POST_MESSAGE') {
					return bindThreeDSListenerEvent(externalUrl, paymentFetchResultFlow, externalParameters);
				}
				return getFingerPrintData({
					accHistRef,
					paymentFetchResultFlow,
					doneCallback
				});
			}
			break;
		case 'TWO_FACTOR_AUTH':
			if (!prevProps.result || prevProps.result.accHistRef !== accHistRef) {
				return setTwoFact();
			}
			break;
		// Our local implement for handling this type deposit
		case 'INTERNAL_PANEL':
			return result;
		default:
			throw new Error(
				'execute-deposit.js:componentDidUpdate: unknown type of actualSendHandler',
				actualSendHandler
			);
	}
}

export default actualSendHandlerEffect;
